/** Guidance for an unmodified server, not a guarantee for arbitrary worlds/plugins/modpacks. */
export function minecraftRuntimeAdvice(core, version, memoryMb = 1024) {
    const match = /^(\d+)\.(\d+)(?:\.(\d+))?$/.exec(version);
    if (!match) {
        return {
            javaVersion: 21,
            warnings: ["Для этой версии требования к Java и памяти нужно проверить отдельно."],
        };
    }
    const major = Number(match[1]), minor = Number(match[2]), patch = Number(match[3] ?? 0);
    const modern = major > 1 || minor >= 17;
    const paperCompatible = core === "paper" || core === "leaf";
    let javaVersion;
    if (major >= 26) {
        javaVersion = 25;
    }
    else if (major > 1 || minor > 20 || (minor === 20 && (paperCompatible || patch >= 5))) {
        javaVersion = 21;
    }
    else if (minor >= 17) {
        javaVersion = 17;
    }
    else if (paperCompatible && minor >= 12) {
        javaVersion = 11;
    }
    else {
        javaVersion = 8;
    }
    const warnings = [];
    if (memoryMb < 2048) {
        if (modern) {
            warnings.push(`Для этой версии Minecraft ${memoryMb === 1024 ? "1 ГБ" : `${memoryMb} МБ`} может не хватить даже при запуске. Рекомендуется от 2 ГБ. Память автоматически не увеличивается.`);
        }
        else if (core === "forge" || core === "fabric" || core === "neoforge") {
            warnings.push(`Для сборок с модами ${memoryMb === 1024 ? "1 ГБ" : `${memoryMb} МБ`} может не хватить. Объём памяти зависит от установленных модов; рекомендуется от 2 ГБ.`);
        }
    }
    return { javaVersion, warnings };
}
